import { useTranslation } from 'react-i18next';
import { useTheme, Typography } from '../../../../base';
import {
    IClientSourceOfHireChartData,
    ReportPeriod,
    TIME_FRAME_OPTIONS,
} from '../../../../common';
import SourceOfHirePieCard from './SourceOfHirePieCard';
import {
    StyledPieViewWrapper,
    StyledHeaderBlock,
    StyledPieRow,
} from './PieView.styles';

interface IPieViewProps {
    chartData: IClientSourceOfHireChartData;
    timeFrame: string;
    startDate: string | null;
    endDate: string | null;
}

const PieView = ({
    chartData,
    timeFrame,
    startDate,
    endDate,
}: IPieViewProps) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const timeFrameOption = TIME_FRAME_OPTIONS.find(
        (option) => option.value === timeFrame
    );
    const periodLabel =
        timeFrame === ReportPeriod.CUSTOM && startDate && endDate
            ? `${startDate} - ${endDate}`
            : timeFrameOption
              ? t(timeFrameOption.label)
              : timeFrame;

    return (
        <StyledPieViewWrapper>
            <StyledHeaderBlock>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    {t('reportsPage.sourceOfHireReport.pieDistributionTitle', {
                        period: periodLabel,
                    })}
                </Typography>
                <Typography variant="body1" color={theme.palette.grey[700]}>
                    {t('reportsPage.sourceOfHireReport.pieViewDescription')}
                </Typography>
            </StyledHeaderBlock>
            <StyledPieRow direction="row">
                <SourceOfHirePieCard
                    distributions={chartData}
                    defaultMetric="hired"
                />
                <SourceOfHirePieCard
                    distributions={chartData}
                    defaultMetric="applications"
                />
            </StyledPieRow>
        </StyledPieViewWrapper>
    );
};

export default PieView;
